import { ComparatorStep } from '@kizi/comparator-core';
import startWidget from './startWidget';
import overview from './overview';
import apply from './apply';
import checkout from './checkout';
import comparison from './comparison';

export const steps: ComparatorStep[] = [
  startWidget,
  overview,
  comparison,
  apply,
  checkout,
];

export default steps;
